import { computed, Injectable, Signal } from '@angular/core';
import { TCalGtmFunnelStepEvent } from '@cal-analytics/gtm';
import { GtmAdapterService } from './gtm-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class GtmAdapterCardService extends GtmAdapterService {
  constructor() {
    super();
  }

  override funnelStepGetter: Signal<Partial<TCalGtmFunnelStepEvent>> = computed(() => ({
    ...this.cardName$$()
  }));

  override funnelEndGetter: Signal<Partial<TCalGtmFunnelStepEvent>> = computed(() => ({
    ...this.cardName$$()
  }));
}
